module.exports = __webpack_public_path__ + "media/images/games/fifa-23/hiw-4-144751545e169a910c7819c9c252ff2d.jpg";